import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    taskId: String
  }

  connect() {
    console.log(`[Icon Sync] Connected for taskId: ${this.taskIdValue}`)
    this.observeIconPreview()
  }

  observeIconPreview() {
    const container = this.element
    if (!container) {
      console.warn("[Icon Sync] No icon preview wrapper found")
      return
    }
    console.log("[Icon Sync] Observing icon preview wrapper")

    this.observer = new MutationObserver(() => {
      console.log("[Icon Sync] Mutation observed")
      this.syncIconField()
    })

    this.observer.observe(container, { childList: true, subtree: true })
  }

  syncIconField() {
    console.log("[Icon Sync] syncIconField called")

    const preview = document.getElementById(`select-icon-display-${this.taskIdValue}`)
    const hiddenField = document.getElementById("selected-icon-field")

    if (!preview || !hiddenField) {
      console.warn("[Icon Sync] Missing preview or hidden field element")
      return
    }

    const iconElement = preview.querySelector("i")
    if (!iconElement) {
      console.warn("[Icon Sync] No <i> element found in preview")
      // Clear the hidden field if no icon element found
      hiddenField.value = ""
      return
    }

    const iconClass = iconElement.className.trim()
    
    // Check if the icon class is valid (not just CSS utility classes)
    if (this.isValidIconClass(iconClass)) {
      hiddenField.value = iconClass
      console.log("[Icon Sync] Updated hidden field with:", iconClass)
    } else {
      // Clear the hidden field if no valid icon class
      hiddenField.value = ""
      console.log("[Icon Sync] Cleared hidden field - no valid icon class found")
    }
  }

  isValidIconClass(className) {
    if (!className) return false
    
    // List of CSS utility classes that aren't actual icons
    const utilityClasses = ['d-none', 'd-block', 'd-inline', 'hidden', 'visible', 'invisible']
    
    // Check if className only contains utility classes
    const classNames = className.split(/\s+/)
    const validIconClasses = classNames.filter(cls => !utilityClasses.includes(cls))
    
    // Should have at least one class that looks like an icon (contains 'fa' or similar)
    return validIconClasses.length > 0 && validIconClasses.some(cls => cls.includes('fa'))
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }
}
